import { MENU_STATE } from './actionTypes';

export function menuState(open) {
    return { type: MENU_STATE, open };
}
